import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: 0 7rem 0 7rem;
  height: 100%;
`;

export const WrapperTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WrapperTitleButton = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WrapperInput = styled.div`
  width: 120%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
`;

export const Title = styled.h1`
  font-family: Montserrat Alternates;
  font-size: 2.8rem;
  font-style: normal;
  font-weight: 800;
  line-height: 3.6rem;
  letter-spacing: 0.02em;
  text-align: left;
  color: #0b1d2e;
`;

export const TitleDescription = styled.span`
  font-family: Montserrat;
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.4rem;
  letter-spacing: 0.02em;
  color: #a4aeb4;
  padding-top: 1.5rem;
`;

export const SmallTitle = styled.h2`
  font-family: Montserrat Alternates;
  font-size: 2.1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2.8rem;
  letter-spacing: 0;
  color: #0b1d2e;
`;
